import React from "react";
import FieldError from "../registration/FieldError";

function EmissionHotelSection({
  language,
  stayedInHotelFlag,
  setStayedInHotelFlag,
  hotelNights,
  setHotelNights,
  isHotelYes,
  setStoredValue,
  formErrors,
}) {
  const t = {
    EN: {
      hotel: "Are you staying at a hotel?",
      nights: "How many nights are you staying?",
      selectOption: "Select an option",
      selectNights: "Select nights",
      yes: "Yes",
      no: "No",
      night: "night",
      nightsPlural: "nights",
    },
    ES: {
      hotel: "¿Te hospedás en un hotel?",
      nights: "¿Cuántas noches te hospedás?",
      selectOption: "Seleccioná una opción",
      selectNights: "Seleccione una cantidad de noches",
      yes: "Sí",
      no: "No",
      night: "noche",
      nightsPlural: "noches",
    },
  };

  return (
    <div className="containerFlex">
      <div className="col-2">
        <label>
          {t[language].hotel} <b>*</b>
        </label>
        <select
          value={stayedInHotelFlag}
          onChange={(e) => {
            const value = e.target.value;
            setStayedInHotelFlag(value);
            setStoredValue("stayed_in_hotel", value);

            if (value === "0") {
              setHotelNights("");
              setStoredValue("hotel_nights", "0");
            } else {
              setHotelNights("");
              setStoredValue("hotel_nights", "");
            }
          }}
        >
          <option value="" disabled>
            {t[language].selectOption}
          </option>
          <option value="1">{t[language].yes}</option>
          <option value="0">{t[language].no}</option>
        </select>
        <FieldError error={formErrors.stayedInHotelFlag} />
      </div>

      <div className="col-2">
        <label>
          {t[language].nights} <b>*</b>
        </label>
        <select
          value={hotelNights}
          name="hotel_nights"
          onChange={(e) => {
            const value = e.target.value;
            setHotelNights(value);
            setStoredValue("hotel_nights", value);
          }}
          disabled={!isHotelYes}
          required={isHotelYes}
        >
          <option value="" disabled>
            {t[language].selectNights}
          </option>
          {[1, 2, 3, 4].map((day) => (
            <option key={day} value={String(day)}>
              {day} {day === 1 ? t[language].night : t[language].nightsPlural}
            </option>
          ))}
        </select>
        <FieldError error={formErrors.hotelNights} />
      </div>
    </div>
  );
}

export default EmissionHotelSection;
